import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from '../../utils/classNames';
/**
 * The SelectOption component represents an option from select component.
 * This component is based on the select-only combobox example provided by APG
 * and is more semantically correct and accessible than the current MenuOption component.
 * Currently, this component only support string for the text and value.
 *
 * - [APG Select-Only Combobox Example](https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/)
 *
 * ## Related Components
 * - [Select](../README.md)
 *
 * ## Props
 */

var SelectOption = function SelectOption(props) {
  var currentIdx = props.currentIdx,
      descendantId = props.descendantId,
      handleKeydown = props.handleKeydown,
      idx = props.idx,
      isSelected = props.isSelected,
      onOption = props.onOption,
      qa = props.qa,
      telemetryMeta = props.telemetryMeta,
      text = props.text,
      trackClick = props.trackClick,
      value = props.value;

  var onOptionSelected = function onOptionSelected() {
    return onOption(idx, text, value);
  };

  var ref = /*#__PURE__*/React.createRef(null);
  useEffect(function () {
    if (ref === null || ref === void 0 ? void 0 : ref.current) {
      if (currentIdx === idx) ref.current.focus();else ref.current.blur();
    }
  }, [currentIdx, ref === null || ref === void 0 ? void 0 : ref.current]);
  return /*#__PURE__*/React.createElement("div", {
    "aria-selected": isSelected,
    "data-qa": "".concat(qa, "#option").concat(idx),
    className: classNames('psw-fill-x', 'psw-p-4', 'psw-m-b-4', 'psw-button', 'psw-option-button', 'psw-select-option', {
      'psw-is-active': currentIdx === idx
    }, 'psw-ally-indicator', 'psw-ally-indicator-gap-0', 'psw-ally-indicator-inset'),
    "data-telemetry-meta": telemetryMeta,
    "data-track-click": trackClick,
    id: descendantId,
    onClick: onOptionSelected,
    onKeyDown: handleKeydown,
    ref: ref,
    role: "option",
    tabIndex: 0
  }, text);
};

SelectOption.defaultProps = {
  currentIdx: -1,
  handleKeydown: function handleKeydown() {},
  isSelected: false,
  onOption: function onOption() {},
  qa: '',
  telemetryMeta: null,
  trackClick: null,
  text: '',
  value: ''
};
SelectOption.propTypes = {
  /**
   * The index of option that is being navigated on
   */
  currentIdx: PropTypes.number,

  /**
   * The id of option that is being used by the select to identify active option
   */
  descendantId: PropTypes.string.isRequired,

  /**
   * The keyboard handler for option
   */
  handleKeydown: PropTypes.func,

  /**
   * The index of this option
   */
  idx: PropTypes.number.isRequired,

  /**
   * Is option being selected?
   */
  isSelected: PropTypes.bool,

  /**
   * Callback called when this option is selected
   */
  onOption: PropTypes.func,

  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
  * Serialized json data of context specific telemetry data
  */
  telemetryMeta: PropTypes.string,

  /**
  * The spec id identifying the interaction
  */
  trackClick: PropTypes.string,

  /**
   * The text for option
   */
  text: PropTypes.string,

  /**
   * The value for option
   */
  value: PropTypes.string
};
export default SelectOption;